import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from './index';
import { catchError, delay, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthState } from './auth.store';

@Injectable()
export class AuthEffects {

  $showLoader = createEffect(() => this.actions$.pipe(
    ofType(
      AuthActions.SignUp,
      AuthActions.Login
    ),
    tap(() => this.store.dispatch(AuthActions.AuthLoading({ loading: true }))),
    delay(3000),
    tap(() => this.store.dispatch(AuthActions.AuthLoading({ loading: false })))
  ), { dispatch: false });

  $hideLoader = createEffect(() => this.actions$.pipe(
    ofType(
      AuthActions.SignUpSuccess,
      AuthActions.SignUpFailure,
      AuthActions.LoginSuccess,
      AuthActions.LoginFailure
    ),
    delay(1500),
    tap(() => this.store.dispatch(AuthActions.AuthLoading({ loading: false })))
  ), { dispatch: false });

  // signUp$ = createEffect(() => this.actions$.pipe(
  //   ofType(AuthActions.SignUp),
  //   switchMap((action) => this.apiService.signUp(action.creds).pipe(
  //     map(res => AuthActions.SignUpSuccess({ payload: { res, email: action.creds.email }  })),
  //     catchError(res => of(AuthActions.SignUpSuccess({ payload: { res, email: action.creds.email } })))
  //     // catchError((err) => of(AuthActions.SignUpFailure({ err })))
  //   ))
  // ));

  signSuccess$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.SignUpSuccess),
    tap((data) => {
      this.router.navigate(['auth/verify'], { state: { email: data.payload.email } });
    })
  ), { dispatch: false });

  verify$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.Verify),
    tap(() => {
      this.router.navigate(['auth/login'], { state: { verify: true } });
    })
  ), { dispatch: false });

  // login$ = createEffect(() => this.actions$.pipe(
  //   ofType(AuthActions.Login),
  //   switchMap((action) => this.apiService.signUp(action.creds).pipe(
  //     map(res => AuthActions.LoginSuccess({ res })),
  //     catchError((err) => of(AuthActions.LoginFailure({ err })))
  //   ))
  // ));

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private router: Router,
    private store: Store<AuthState>
  ) { }

}
